import { Injectable, signal } from '@angular/core';

// Service to share currently selected legal entity name across components (list -> toolbar)
@Injectable({ providedIn: 'root' })
export class SelectedLegalEntityService {
  // holds the selected legal entity name; empty string means none selected yet
  private _name = signal<string>('');
  // holds the selected legal entity ID; null means none selected yet
  private _id = signal<number | null>(null);
  // holds status code/value from detail endpoint; empty string means unknown/unloaded
  private _status = signal<string>('');
  // holds the bcr_status_id for API calls
  private _bcrStatusId = signal<number | null>(null);
  // loading flag while fetching detail
  private _statusLoading = signal<boolean>(false);

  name() {
    return this._name();
  }

  setName(value: string) {
    this._name.set(value);
  }

  id() {
    return this._id();
  }

  setId(value: number | null) {
    this._id.set(value);
  }

  status() {
    return this._status();
  }

  setStatus(value: string) {
    this._status.set(value);
  }

  bcrStatusId() {
    return this._bcrStatusId();
  }

  setBcrStatusId(value: number | null) {
    this._bcrStatusId.set(value);
  }

  statusLoading() {
    return this._statusLoading();
  }

  setStatusLoading(value: boolean) {
    this._statusLoading.set(value);
  }

  clear() {
    this._name.set('');
    this._id.set(null);
    this._status.set('');
    this._bcrStatusId.set(null);
    this._statusLoading.set(false);
  }
}
